import { c as _c } from "react/compiler-runtime";
import { trackEvent } from '@svs/nova-core/nextjs/analytics';
import { useIsCouponWagerPending } from '@svs/nova-poolbetting/core/frameworks/nextjs/coupon';
import type { ExternalWagerSelectedSystemType } from '@svs/nova-poolbetting/schema/wager';
import { Betslip, BetslipExternalLabel, BetslipLabel, BetslipPayButton, BetslipPrice } from '@svs/nova-poolbetting/ui/Betslip';
import { ShowHideButton } from '@svs/nova-poolbetting/ui/ShowHideButton';
import Balance from '@svs/ui/react/icons/Balance';
import type { ReactNode } from 'react';
const handleOpenDrawerClick = (): void => {
  trackEvent({
    category: 'Nya tipsen',
    action: 'Coupon overview',
    optLabel: 'Powerplay'
  });
};
type BetslipExternalProps = {
  betslipProps: {
    price: string;
    selectedSystem: ExternalWagerSelectedSystemType;
    betslipContent: ReactNode;
    balance: number;
    handleBalanceClick?: () => void;
    numberOfRows: number;
  };
};

/**
 * Component för external betslip.
 *
 * @param props - The props object.
 * @param props.betslipProps - Correct props for the external betslip component.
 * @returns external betslip component
 */
function BetslipExternal(t0) {
  const $ = _c(20);
  const {
    betslipProps
  } = t0;
  const {
    price,
    numberOfRows,
    selectedSystem,
    betslipContent,
    balance,
    handleBalanceClick
  } = betslipProps;
  const isPending = useIsCouponWagerPending();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["[grid-template-areas:'label_hedges_price''payButton_payButton_payButton']", "grid-cols-[min-content_auto_minmax(40px,_80px)]", "lg:[grid-template-areas:'label_hedges_balance_price_payButton']", "lg:grid-cols-[max-content_auto_minmax(60px,_120px)_minmax(40px,_80px)_minmax(154px,_250px)]"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const betslipClassNames = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <BetslipLabel label="Externa systemspel" />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== numberOfRows || $[3] !== selectedSystem) {
    t3 = <BetslipExternalLabel typeOfSystem={selectedSystem} numberOfSystems={numberOfRows} />;
    $[2] = numberOfRows;
    $[3] = selectedSystem;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `${balance} kr`;
  let t5;
  if ($[5] !== handleBalanceClick || $[6] !== t4) {
    t5 = <ShowHideButton className="text-layer-fg-muted hidden font-normal [grid-area:balance] lg:grid lg:grid-cols-[max-content_auto]" showValue={t4} hideValue="Visa saldo" variant="ghost" onClick={handleBalanceClick} Icon={Balance} />;
    $[5] = handleBalanceClick;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== isPending) {
    t6 = <BetslipPayButton hasAdditions={false} disabled={isPending} />;
    $[8] = isPending;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== price) {
    t8 = <BetslipPrice price={price} />;
    $[13] = price;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== betslipContent || $[16] !== t3 || $[17] !== t7 || $[18] !== t8) {
    t9 = <Betslip className={betslipClassNames.join(" ")} isPopulatedCoupon={true} betslipContent={betslipContent} onOpenDrawerClick={handleOpenDrawerClick}>{t2}{t3}{t7}{t8}</Betslip>;
    $[15] = betslipContent;
    $[16] = t3;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
export default BetslipExternal;